import { FamilyProfile } from '../types/familyProfile';

/**
 * Starting values for taste-profile fields a user hasn't answered yet. Shared by
 * the onboarding wizard and the profile page so an unset field reads the same in
 * both places.
 */
export const DEFAULT_COOKING_SKILL: FamilyProfile['cookingSkill'] = 'intermediate';

export const DEFAULT_PROTEIN_DIVERSITY: NonNullable<FamilyProfile['proteinDiversity']> = 'moderate';

export const DEFAULT_ADULTS = 2;

export const DEFAULT_KIDS = 0;

// Solo households get leftovers by default - cooking one portion at a time is
// rarely worth it, so we plan larger batches unless they say otherwise.
export const defaultIncludeLeftovers = (adults: number, kids: number) => adults + kids === 1;
